export default {
  name: "Editor",
  path: "/",
  meta: {
    title: "吉鸟AI",
  },
};
